<template>
  <UIBaseTransition>
    <UILoader v-if="authStore.getIsLoadingAgent" />
    <div v-else ref="info" class="flex w-full flex-col gap-4 4xl:gap-6 5xl:gap-8">
      <div class="flex flex-row items-center gap-2 px-3 py-2.5 4xl:text-3xl 5xl:text-5xl">
        <UIIcon name="user-group" />
        {{ $t('navigation.drawer.myConsultant') }}
      </div>
      <img
        :src="authStore.agent?.image || '/images/agent-default.png'"
        :alt="authStore.agent?.name || 'Hafiz Sheikh'"
        class="h-[40%] w-full rounded-lg object-cover object-top 4xl:h-[70%]"
      />
      <div class="flex flex-col 4xl:gap-4">
        <h2 class="font-bold text-white 4xl:text-3xl 5xl:text-5xl">{{ authStore.agent?.name || 'Hafiz Sheikh' }}</h2>
        <span class="4xl:text-2xl 5xl:text-4xl">
          {{ $t('navigation.drawer.expert') }}
        </span>
      </div>
      <div class="flex w-full flex-row items-center justify-between border-y border-solid border-black-70 py-2">
        <div class="text-body-3 flex flex-row items-center text-gold-primary-100">
          <UIIcon name="star-filled" size="sm" />
          <UIIcon name="star-filled" size="sm" />
          <UIIcon name="star-filled" size="sm" />
          <UIIcon name="star-filled" size="sm" />
          <UIIcon name="star-filled" size="sm" />
        </div>
        <span class="text-black-30 4xl:text-xl 5xl:text-2xl"> 4.8 rating </span>
      </div>
      <div class="flex flex-col gap-2 4xl:gap-4">
        <NuxtLink
          class="line-clamp-1 flex w-full flex-row items-center gap-2 text-sm 4xl:text-2xl 5xl:text-4xl"
          :to="`tel:${authStore.agent?.phone || '+971 52 138 5233'}`"
        >
          <div class="flex aspect-square size-6 items-center justify-center rounded-full bg-black-70">
            <UIIcon name="phone" size="xs" class="text-gold-primary-100" />
          </div>
          {{ authStore.agent?.phone || '+971 52 138 5233' }}
        </NuxtLink>
        <button
          class="line-clamp-1 flex w-full flex-row items-center gap-2 text-sm 4xl:text-2xl 5xl:text-4xl"
          @click="openContactAgentPopup"
        >
          <div class="flex aspect-square size-6 items-center justify-center rounded-full bg-black-70">
            <UIIcon name="email" size="xs" class="text-gold-primary-100" />
          </div>
          {{ authStore.agent?.email || 'hafiz@thrivestate.io' }}
        </button>
      </div>
    </div>
  </UIBaseTransition>
</template>

<script setup lang="ts">
import { POPUPS } from '@/components/dynamic/maps'

const uiStore = useUIStore()
const authStore = useAuthStore()

const openContactAgentPopup = () => {
  uiStore.showPopup(POPUPS.CONTACT_AGENT)
}
</script>

<style scoped></style>
